import { cubicEaseOut } from '@helpers/animate';
import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { underline } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.a `
  display: flex;
  align-items: center;
  background: ${rgba(brand.lightGrey, 0)};
  border: 2px solid ${rgba(brand.green.dark, 0)};
  border-radius: 8px;
  color: currentColor;
  outline: none;
  padding: 8px 24px;
  text-decoration: none;
  transition: background-color 0.3s ${cubicEaseOut}, color 0.3s ${cubicEaseOut};

  [data-cta-theme='light'] & {
    background: ${rgba(brand.white, 0)};
    border: 2px solid ${brand.white};
    color: ${brand.white};
  }

  [data-cta-theme='dark'] & {
    background: ${rgba(brand.black, 0)};
    border: 2px solid ${brand.black};
    color: ${brand.black};
  }

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }

  &:hover {
    background: ${rgba(brand.lightGrey, 1)};
    border-color: ${rgba(brand.green.dark, 1)};

    [data-cta-theme='light'] & {
      background: ${rgba(brand.white, 1)};
      border-color: ${brand.white};
      color: ${brand.black};
    }

    [data-cta-theme='dark'] & {
      background: ${rgba(brand.black, 1)};
      border-color: ${brand.black};
      color: ${brand.white};
    }
  }
`;
const IconWrapper = styled.div `
  flex: 0 0 auto;
`;
const Icon = styled.img `
  display: block;
  height: 24px;
  margin-right: 10px;
  object-fit: contain;
  object-position: center;
  width: 24px;

  @media ${from(Device.Tablet)} {
    height: 32px;
    width: 32px;
  }

  [data-cta-theme='light'] ${Container}:not(:hover) & {
    filter: brightness(0) invert(1);
  }

  [data-cta-theme='dark'] ${Container}:hover & {
    filter: brightness(0) invert(1);
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 6px;
`;
const Telephone = styled.div `
  ${fonts.montserrat.regular};
`;
const TelephoneLabel = styled.span `
  ${fonts.montserrat.bold};
  font-size: 15px;
  padding-right: 0.5ch;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
  }
`;
const TelephoneValue = styled.span `
  ${underline};
`;
const Hours = styled.div `
  ${fonts.montserrat.regular};
  font-size: 13px;

  @media ${from(Device.Tablet)} {
    font-size: 14px;
  }
`;
const HoursLabel = styled.span `
  ${fonts.montserrat.bold};
  padding-right: 0.5ch;
`;
const HoursValue = styled.span ``;
const CallButtonStyles = {
    Container,
    ContentWrapper,
    Hours,
    HoursLabel,
    HoursValue,
    Icon,
    IconWrapper,
    Telephone,
    TelephoneLabel,
    TelephoneValue,
};
export default CallButtonStyles;
